<template>
  <div>
    <div :class="['container_PTable', classFieldFixed]" v-show="hayDatos">
      <table :class="['table_PTable', tableClass]" aria-describedby="table">
        <thead class="thead_PTable">
          <tr>
            <th
              :class="['th_PTable', giveClassTh(field)]"
              v-for="(field, index) in fields"
              :key="index + 'th_PTable'"
            >
              <div class="thContainer_PTable">
                <div>{{ field.label }}</div>
                <p-drop-down-container
                  :id="index + field.label"
                  v-if="
                    field.showOrderField ||
                    field.showGroupedField ||
                    field.showHideField ||
                    field.showFilterField
                  "
                >
                  <template v-slot:content>
                    <div class="thDivContainer_PTable">
                      <div class="thDivDown_PTable">
                        <div class="expand_moreSelect_PTable">
                          <span class="material-icons-outlined">expand_more</span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <div class="thDivOptions_PTable">
                    <div
                      @click="actionTable(field, 'ASC')"
                      class="thDivOptionsActions_PTable"
                      v-if="field.showOrderField"
                    >
                      {{ traductor.orderAsc }}
                    </div>
                    <div
                      @click="actionTable(field, 'DESC')"
                      class="thDivOptionsActions_PTable"
                      v-if="field.showOrderField"
                    >
                      {{ traductor.orderDes }}
                    </div>
                    <div class="hrSeparador" v-if="field.showOrderField" />
                    <div
                      @click="actionTable(field, 'COMP')"
                      :class="
                        field.groupedField
                          ? 'thDivOptionsActionsSelected_PTable'
                          : 'thDivOptionsActions_PTable'
                      "
                      v-if="field.showGroupedField"
                    >
                      <div
                        class="thDivOptionsActionsSelectedMark_PTable"
                        v-if="field.groupedField"
                      ></div>
                      {{ traductor.compressData }}
                    </div>
                    <div
                      @click="actionTable(field, 'EXP')"
                      :class="
                        !field.groupedField
                          ? 'thDivOptionsActionsSelected_PTable'
                          : 'thDivOptionsActions_PTable'
                      "
                      v-if="field.showGroupedField"
                    >
                      <div
                        class="thDivOptionsActionsSelectedMark_PTable"
                        v-if="!field.groupedField"
                      ></div>
                      {{ traductor.extendData }}
                    </div>
                    <div class="hrSeparador" v-if="field.showGroupedField" />
                    <div
                      @click.self="actionTable(field, 'OCU')"
                      class="thDivOptionsActions_PTable"
                      v-if="field.showHideField"
                    >
                      {{ traductor.hideColumn }}
                    </div>
                    <div class="hrSeparador" />
                    <div class="thDivOptionsActions_PTable" v-if="field.showFilterField">
                      <div>{{ traductor.filter }}</div>
                      <div class="thDivOptionsActionsChecks_PTable">
                        <p-form-check-box
                          :id="'checkAll_PTabl' + field.key + index"
                          :checked="true"
                          label="Todos"
                        />

                        <p-form-check-box
                          :id="index_checks + 'filtroscheck' + field.key + index"
                          v-model="filterCheck[index]"
                          :value="checkFilterField.label"
                          unchecked_value=""
                          v-for="(checkFilterField, index_checks) in optionsCheckFilterFields(
                            field
                          )"
                          :label="checkFilterField.text"
                          :key="index_checks + 'filtroscheck' + field.key + index"
                        ></p-form-check-box>
                      </div>
                    </div>
                  </div>
                </p-drop-down-container>
              </div>
              <div class="thContainerIcons_PTable">
                <p-icon
                  :icon="iconOrder"
                  type="material"
                  size="10"
                  color="#ffd102"
                  v-if="isOrderFiels(field)"
                ></p-icon>
                <p-icon
                  icon="push_pin"
                  type="material"
                  size="10"
                  v-if="field.groupedField"
                ></p-icon>
                <p-icon
                  icon="IconFilter"
                  size="10"
                  color="#ffd102"
                  v-if="field.filter.leng"
                ></p-icon>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tr_PTable" v-for="(item, index) in itemsComp" :key="index + 'tr_PTable'">
            <td
              class="td_PTable"
              v-for="(field, index2) in fields"
              :key="index2 + 'td_PTable'"
              :style="giveMeMaxSizeRowSpan(field, 'td', item, index2, index)"
              :rowSpan="rowSpan(field, item, index)"
            >
              <div :style="giveMeMaxSize(field, 'divTd')" :class="givemeClassTypeField(field)">
                <slot :name="'cell(' + field.key + ')'" :row="item">
                  {{ formatFiled(field, item) }}
                </slot>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <p-pagination
      v-model="valueLocal.pagination.currentPage"
      :page-size="valueLocal.pagination.pageSize"
      :total-elements="valueLocal.pagination.totalElements"
      @change="change"
      :firstLastButtons="true"
      v-show="pagination && hayDatos"
    />
    <div class="NoData" v-if="!hayDatos">
      {{ textEnmty }}
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PPagination from "../PPagination/PPagination.vue";
import PFormInputPredictiveSearch from "../PFormInput/PFormInputPredictiveSearch.vue";
import PFormCheckBox from "../PFormCheckBox/PFormCheckBox.vue";
import PIcon from "../PIcon/PIcon.vue";
import { FieldPTableType, PTableType } from "./pTable.type";
import { ITranslationsTable, translations } from "./languajesTable";

@Component({
  components: {
    PPagination,
    PFormInputPredictiveSearch,
    PFormCheckBox,
    PIcon,
  },
})
export class PTable extends Vue {
  @Prop({ required: true }) value!: PTableType;
  @Watch("value", { deep: true, immediate: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
    this.fieldsFormatter = this.fieldsFormatter.concat(this.value.fields);

    this.initValoresTdAnteriores();
  }
  @Prop({ required: true }) items!: any[];
  @Watch("items", { deep: true, immediate: true })
  onChangeItems(): void {
    if (!this.paginationServer) {
      this.valueLocal.pagination.totalElements = this.items.length;
    }
  }
  @Prop({ required: false, default: "" }) tableClass!: string;
  @Prop({ required: false, default: false }) pagination!: boolean;
  @Prop({ required: false, default: false }) paginationServer!: boolean;
  @Prop({ required: false, default: "No hay datos que mostrar" }) textEnmty!: string;
  @Prop({ required: false, default: "es" }) language!: string;

  traductor: ITranslationsTable = translations[0].translations;
  valueLocal: PTableType = {
    fields: [],
    pagination: {
      pageSize: 10,
      totalElements: 100,
      currentPage: 1,
    },
    order: {
      orderField: "divisa",
      orderDirection: "DESC",
      groupedFields: [],
    },
  };
  fieldsFormatter: FieldPTableType[] = []; //lo necesito porque sino pierdo las funciones de formatter
  valoresTdAnteriores: string[] = [];
  filterCheck: string[] = [];
  hayDatos = false;
  created(): void {
    const languaje = translations.find((tran) => tran.language === this.language)?.translations;
    if (languaje) {
      this.traductor = languaje;
    }
  }

  get fields(): FieldPTableType[] {
    return this.value.fields.filter((fie: FieldPTableType) => fie?.show);
  }
  get itemsComp(): any[] {
    if (this.paginationServer) {
      if (this.items.length > 0) {
        this.hayDatos = true;
      }
      return this.items;
    } else {
      let itemsTemp: any[] = this.items.slice();
      //Lo primero ordenamos por el campo que se quiere ordenar
      itemsTemp = itemsTemp.sort((x, y) => {
        return this.sortLocal(
          x,
          y,
          this.valueLocal.order.orderField,
          this.valueLocal.order.orderDirection
        );
      });

      //reocrremos los campos con agrupaciones de forma inversa y ordenamos
      const groupedFieldsReverse = this.valueLocal.order.groupedFields.slice().reverse();
      groupedFieldsReverse.forEach((key) => {
        let direction = "DESC";
        if (this.valueLocal.order.orderField === key) {
          direction = this.valueLocal.order.orderDirection;
        }
        itemsTemp = itemsTemp.sort((x, y) => {
          return this.sortLocal(x, y, key, direction);
        });
      });
      if (itemsTemp.length > 0) {
        this.hayDatos = true;
      }

      const iniItems =
        this.valueLocal.pagination.currentPage * this.valueLocal.pagination.pageSize -
        this.valueLocal.pagination.pageSize;
      const finItems = iniItems + this.valueLocal.pagination.pageSize;
      //

      return itemsTemp.slice(iniItems, finItems);
    }
  }
  givemeClassTypeField(field: FieldPTableType): string {
    if (field.type === "action") {
      return "tdActions_PTable";
    } else {
      return "";
    }
  }
  sortLocal(x: any, y: any, key: string, direction: string): number {
    if (direction === "DESC") {
      if (x[key] < y[key]) {
        return -1;
      }
      if (x[key] > y[key]) {
        return 1;
      }
      return 0;
    } else if (direction === "ASC") {
      if (x[key] < y[key]) {
        return 1;
      }
      if (x[key] > y[key]) {
        return -1;
      }
      return 0;
    } else {
      return 0;
    }
  }
  initValoresTdAnteriores(): void {
    const numfileds = this.value.fields.filter((fie: FieldPTableType) => fie?.show).length;
    this.valoresTdAnteriores = new Array(numfileds);
  }
  formatFiled(field: any, item: any): any {
    const filedTemp: any = this.fieldsFormatter.find((fi: FieldPTableType) => fi.key == field.key);

    if (filedTemp?.formatter) {
      return filedTemp.formatter(item[field.key]);
    } else {
      return item[field.key];
    }
  }
  giveMeMaxSizeRowSpan(
    field: any,
    element: string,
    item: any,
    index: number,
    indexItem: number
  ): string {
    let returnTemp = this.giveMeMaxSize(field, element);
    if (field.fixColumn) {
      if (indexItem % 2 == 0) {
        returnTemp =
          returnTemp +
          "position: sticky; right: 0;background-color: #fafafa;box-shadow: 1px 0 rgba(0, 0, 0, 0.16) inset;";
      } else {
        returnTemp =
          returnTemp +
          "position: sticky; right: 0;background-color: #f1f1f1;box-shadow: 1px 0 rgba(0, 0, 0, 0.16) inset;";
      }
    }
    if (field.groupedField) {
      if (this.valoresTdAnteriores[index] === this.formatFiled(field, item)) {
        returnTemp = returnTemp + "display:none;";
      }
      this.valoresTdAnteriores[index] = this.formatFiled(field, item);
    } else {
      this.valoresTdAnteriores[index] = "";
    }

    return returnTemp;
  }
  giveClassTh(field: FieldPTableType): string {
    if (field.fixColumn) {
      return "fixColumn";
    } else {
      return "";
    }
  }
  giveMeMaxSize(field: FieldPTableType, element: string): string {
    let returnTemp = "";
    if (field.width) {
      if (!(field.type != "action" && element === "divTd")) {
        returnTemp = "width:" + field.width + ";";
      }
    } else {
      const numFields = this.fields.length;
      if (element === "divTd") {
        returnTemp = "width:100%;";
      } else {
        returnTemp = "max-width:" + 100 / numFields + "%;";
      }
    }

    return returnTemp;
  }
  optionsCheckFilterFields(field: FieldPTableType): any[] {
    const returnTemp: any[] = [];
    this.itemsComp.forEach((it) => {
      const valor = this.formatFiled(field, it);
      returnTemp.push({ value: valor, text: valor });
    });
    return returnTemp;
  }
  accionExp(field: any): boolean {
    const array = [2, 5, 9];
    const index = array.indexOf(5);
    if (index > -1) {
      array.splice(index, 1);
    }
    // array = [2, 9]
    //Debemos eliminar de groupedFields el campo que vallamos a desagrupar
    const indexAEliminar = this.valueLocal.order.groupedFields.findIndex((gr) => gr === field.key);
    if (indexAEliminar > -1) {
      this.valueLocal.order.groupedFields.splice(indexAEliminar, 1);
    }
    this.valueLocal.pagination.currentPage = 1;
    this.initValoresTdAnteriores();
    return false;
  }
  accionComp(field: any): boolean {
    //DEbemos comprobar si nuestro field esta en groupedFields y añadirlo al array segun el orden del field
    const estaFieldEnGroupedFields = this.valueLocal.order.groupedFields.find(
      (gr) => gr === field.key
    );
    const indexfieldAInsertar = this.valueLocal.fields.findIndex(
      (fi: FieldPTableType) => fi.key === field.key
    );
    if (!estaFieldEnGroupedFields) {
      //como no esta prodemos a insertarlo
      let posicionEnArray = 0;
      //pero antes tenemos que ver en que posicion lo vamos a insertar
      //para recorremos el groupedFields y vemos los indices con los que corresponden los ya insertados en los fields
      this.valueLocal.order.groupedFields.forEach((gr, index) => {
        const indexYaInsertado = this.valueLocal.fields.findIndex(
          (fi: FieldPTableType) => fi.key === gr
        );

        if (indexfieldAInsertar > indexYaInsertado) {
          posicionEnArray = index + 1;
        }
      });

      //como no esta lo añadimos
      this.valueLocal.order.groupedFields.splice(posicionEnArray, 0, field.key);
    }
    this.valueLocal.pagination.currentPage = 1;
    this.initValoresTdAnteriores();
    return true;
  }
  actionTable(field: any, accion: string): void {
    const fieldTemp: any = this.valueLocal.fields.find(
      (fi: FieldPTableType) => fi.key === field.key
    );
    if (accion === "ASC") {
      this.valueLocal.order.orderField = field.key;
      this.valueLocal.order.orderDirection = "ASC";
      this.valueLocal.pagination.currentPage = 1;
    } else if (accion === "DESC") {
      this.valueLocal.order.orderField = field.key;
      this.valueLocal.order.orderDirection = "DESC";
      this.valueLocal.pagination.currentPage = 1;
    } else if (accion === "COMP") {
      fieldTemp.groupedField = this.accionComp(field);
    } else if (accion === "EXP") {
      fieldTemp.groupedField = this.accionExp(field);
    } else if (accion === "OCU") {
      this.initValoresTdAnteriores();
      fieldTemp.show = false;
    }

    this.$emit("input", this.valueLocal);
    if (this.paginationServer) {
      this.$emit("change", this.valueLocal);
    }
  }
  rowSpan(field: any, item: any, indexRow: number): number {
    if (field.groupedField) {
      const valorTemp = this.formatFiled(field, item);
      let numRowSpan = 0;
      let i = indexRow;
      while (i < this.itemsComp.length && valorTemp == this.formatFiled(field, this.itemsComp[i])) {
        i++;
        numRowSpan++;
      }
      return numRowSpan;
    } else {
      return 1;
    }
  }
  get iconOrder(): string {
    if (this.valueLocal.order.orderDirection == "ASC") {
      return "north";
    } else {
      return "south";
    }
  }
  get classFieldFixed(): string {
    const fieldFixed = this.value.fields.find((fi) => fi.fixColumn);
    if (fieldFixed) {
      return "classFieldFixed";
    } else {
      return "";
    }
  }
  isOrderFiels(filed: FieldPTableType): boolean {
    return this.valueLocal.order.orderField === filed.key;
  }

  change(): void {
    this.$emit("input", this.valueLocal);
    if (this.paginationServer) {
      this.$emit("change", this.valueLocal);
    }
  }
}
export default PTable;
</script>
<style scoped>
.classFieldFixed {
  overflow-x: auto;
}
.container_PTable {
  width: 100%;
  min-height: 260px;
}

.table_PTable,
.th_PTable,
.td_PTable,
.thActions_PTable {
  border: solid 1px #dde3e8;
}
.thActions_PTable,
.tdActionsPTabl {
  width: 35px;
}
.tdActions_PTable {
  padding: 0 4px !important;
  display: flex;
}
.tdActions_PTable div {
  display: none;
}
.tdActions_PTable div:hover {
  background-color: rgba(216, 216, 216, 0.5);
}
.tdActions_PTable div svg {
  margin-top: -6px;
}

.table_PTable {
  width: 100%;
  background-color: #fafafa;
}
.th_PTable {
  position: relative;
  font-size: 0.65rem;
  font-weight: 500;
  line-height: 1.78;
  color: #323232;
  height: 35px;
  padding: 5px 5px 6px 5px;
  background-color: #ffffff;
}
.thContainer_PTable {
  display: flex;
  justify-content: space-between;
}
.thContainerIcons_PTable {
  position: absolute;
  bottom: -6px;
}

.tr_PTable:nth-child(even) {
  /* styles here */
  background-color: #f1f1f1;
}
.tr_PTable:hover {
  background-color: rgba(255, 209, 2, 0.1);
  border: solid 1px #dde3e8;
}
.tr_PTable:hover .tdActions_PTable div {
  display: block;
}

.td_PTable {
  line-height: 1.6;
  color: #323232;
  font-size: 0.7rem;
}
.td_PTable div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 5px;
}

.thDivContainer_PTable {
  display: flex;
  white-space: nowrap;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.th_PTable:hover {
  background-color: rgba(255, 209, 2, 0.1);
}
.th_PTable:hover .expand_moreSelect_PTable {
  background-color: #faf5e0;
}
.th_PTable:hover .thContainer_PTable {
  padding-right: 0;
}

.expand_moreSelect_PTable {
  width: 14px;
  height: 16px;
  object-fit: contain;
  border-radius: 2px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);

  margin-left: 5px;
}
.material-icons-outlined {
  font-size: 15px;
  margin-top: 1px;
  margin-left: -1px;
}
.thDivOptions_PTable {
  position: relative;
  padding: 10px;
}
.thDivOptionsActionsSelected_PTable,
.thDivOptionsActions_PTable {
  padding: 10px 0;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  white-space: nowrap;
  color: #4c4c4c;
}
.thDivOptionsActionsSelected_PTable {
  color: #d7b000;
}
.thDivOptionsActionsSelectedMark_PTable {
  width: 4px;
  height: 38px;
  background-color: #ffd102;
  position: absolute;
  margin-left: -15px;
  margin-top: -10px;
}
.thDivOptionsActionsSelected_PTable:hover,
.thDivOptionsActions_PTable:hover {
  color: rgba(255, 209, 2, 0.5);
}
.hrSeparador {
  opacity: 0.13;
  border: solid 1px #979797;
}
.thDivOptionsActionsChecks_PTable {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  padding-right: 10px;
}
.thDivOptionsActionsChecks_PTable label {
  margin: 0 !important;
  transform: scale(0.8, 0.8);
}
.fixColumn {
  position: sticky;
  right: 0;
  box-shadow: 1px 0 rgba(0, 0, 0, 0.16) inset;
}
.NoData {
  padding: 30px;
  text-align: center;
  object-fit: contain;
  border-radius: 6px;
  border: solid 1px #dde3e8;
  background-color: #fff;
}
</style>
